import { createStyles, makeStyles } from '@material-ui/core';
export var useGroupStyle = makeStyles(function (theme) {
    return createStyles({
        content: {
            position: "absolute",
        },
        root: {
            marginBottom: theme.spacing(2),
            position: "relative",
        },
    });
});
//# sourceMappingURL=group.style.js.map